import { convertNumberIntoE164 } from 'Utils/phoneUtil';
import { StateCreator } from 'zustand';
import { OptOutSlice, OptOutSliceState } from './index.types';

const initialState: OptOutSliceState = {
  optOutPhoneNumbersInfo: new Map<string, boolean>(),
};

export const createOptOutSlice: StateCreator<OptOutSlice> = (set, get) => ({
  ...initialState,
  updateOptOutPhoneNumberInfo: (phoneNumber, isOptedOut) => {
    const e164Phone = convertNumberIntoE164(phoneNumber);

    const optOutPhoneNumbersInfo = new Map(get().optOutPhoneNumbersInfo);

    optOutPhoneNumbersInfo.set(e164Phone, isOptedOut);

    set({ optOutPhoneNumbersInfo });
  },
  getOptOutPhoneNumberInfo: (phoneNumber) => {
    if (!phoneNumber) {
      return undefined;
    }

    const e164Phone = convertNumberIntoE164(phoneNumber);

    return get().optOutPhoneNumbersInfo.get(e164Phone);
  },
});
